/** * TABELA ÚNICA DE VIDA ÚTIL DAS EDIFICAÇÕES
 * PADRÃO IBAPE / NBR 14653
 * INTEGRALIDADE TOTAL - 2026
 */

export const TEXTO_CITACAO_LAUDO = "As vidas úteis das edificações foram definidas conforme uso, tipologia e padrão construtivo, com base em prática pericial consolidada e diretrizes adotadas pelo IBAPE, em consonância com a ABNT NBR 14653, sendo utilizadas como critério auxiliar para homogeneização física e aplicação da Tabela Ross-Heidecke.";

export const TABELA_IBAPE = [
  // --- RESIDENCIAL ---
  { uso: "RESIDENCIAL", tipologia: "BARRACO", padrao: "RÚSTICO", vida: 5 },
  { uso: "RESIDENCIAL", tipologia: "BARRACO", padrao: "SIMPLES", vida: 10 },
  { uso: "RESIDENCIAL", tipologia: "CASA", padrao: "MADEIRA", vida: 45 },
  { uso: "RESIDENCIAL", tipologia: "CASA", padrao: "RÚSTICO", vida: 60 },
  { uso: "RESIDENCIAL", tipologia: "CASA", padrao: "ECONÔMICO", vida: 70 },
  { uso: "RESIDENCIAL", tipologia: "CASA", padrao: "SIMPLES", vida: 70 },
  { uso: "RESIDENCIAL", tipologia: "CASA", padrao: "MÉDIO", vida: 70 },
  { uso: "RESIDENCIAL", tipologia: "CASA", padrao: "FINO", vida: 60 },
  { uso: "RESIDENCIAL", tipologia: "CASA", padrao: "LUXO", vida: 60 },
  { uso: "RESIDENCIAL", tipologia: "APARTAMENTO", padrao: "ECONÔMICO", vida: 60 },
  { uso: "RESIDENCIAL", tipologia: "APARTAMENTO", padrao: "SIMPLES", vida: 60 },
  { uso: "RESIDENCIAL", tipologia: "APARTAMENTO", padrao: "MÉDIO", vida: 60 },
  { uso: "RESIDENCIAL", tipologia: "APARTAMENTO", padrao: "FINO", vida: 50 },
  { uso: "RESIDENCIAL", tipologia: "APARTAMENTO", padrao: "LUXO", vida: 50 },

  // --- COMERCIAL ---
  { uso: "COMERCIAL", tipologia: "ESCRITÓRIO", padrao: "ECONÔMICO", vida: 70 },
  { uso: "COMERCIAL", tipologia: "ESCRITÓRIO", padrao: "SIMPLES", vida: 70 },
  { uso: "COMERCIAL", tipologia: "ESCRITÓRIO", padrao: "MÉDIO", vida: 60 },
  { uso: "COMERCIAL", tipologia: "ESCRITÓRIO", padrao: "FINO", vida: 50 },
  { uso: "COMERCIAL", tipologia: "ESCRITÓRIO", padrao: "LUXO", vida: 50 },
  { uso: "COMERCIAL", tipologia: "LOJA", padrao: "LOJA DE RUA", vida: 70 },

  // --- INSTITUCIONAL / SERVIÇOS / CULTURAL ---
  { uso: "INSTITUCIONAL", tipologia: "BANCO", padrao: "AGÊNCIA BANCÁRIA", vida: 70 },
  { uso: "SERVIÇOS", tipologia: "HOTEL", padrao: "HOTEL", vida: 50 },
  { uso: "CULTURAL", tipologia: "TEATRO", padrao: "TEATRO", vida: 50 },
  { uso: "CULTURAL", tipologia: "CINEMA", padrao: "CINEMA", vida: 50 },
  { uso: "CULTURAL", tipologia: "CASA DE ESPETÁCULOS", padrao: "MÉDIO", vida: 50 },

  // --- INDUSTRIAL ---
  { uso: "INDUSTRIAL", tipologia: "ARMAZÉM", padrao: "ESTRUTURA METÁLICA", vida: 75 },
  { uso: "INDUSTRIAL", tipologia: "GALPÃO", padrao: "ECONÔMICO", vida: 60 },
  { uso: "INDUSTRIAL", tipologia: "GALPÃO", padrao: "SIMPLES", vida: 60 },
  { uso: "INDUSTRIAL", tipologia: "GALPÃO", padrao: "MÉDIO", vida: 80 },
  { uso: "INDUSTRIAL", tipologia: "GALPÃO", padrao: "SUPERIOR", vida: 80 },
  { uso: "INDUSTRIAL", tipologia: "COBERTURA", padrao: "RÚSTICO", vida: 20 },
  { uso: "INDUSTRIAL", tipologia: "COBERTURA", padrao: "SIMPLES", vida: 20 },
  { uso: "INDUSTRIAL", tipologia: "COBERTURA", padrao: "SUPERIOR", vida: 30 },
  { uso: "INDUSTRIAL", tipologia: "FÁBRICA", padrao: "FÁBRICA", vida: 50 },

  // --- RURAL ---
  { uso: "RURAL", tipologia: "SILO", padrao: "METÁLICO / CONCRETO", vida: 75 },
  { uso: "RURAL", tipologia: "ARMAZÉM AGRÍCOLA", padrao: "SIMPLES", vida: 60 },
  { uso: "RURAL", tipologia: "ARMAZÉM AGRÍCOLA", padrao: "MÉDIO", vida: 70 },
  { uso: "RURAL", tipologia: "TULHA", padrao: "MADEIRA / CONCRETO", vida: 50 },
  { uso: "RURAL", tipologia: "ESTÁBULO", padrao: "SIMPLES", vida: 50 },
  { uso: "RURAL", tipologia: "CURRAL", padrao: "SIMPLES", vida: 40 },
  { uso: "RURAL", tipologia: "CURRAL", padrao: "MÉDIO", vida: 50 },
  { uso: "RURAL", tipologia: "AVIÁRIO", padrao: "SIMPLES", vida: 30 },
  { uso: "RURAL", tipologia: "AVIÁRIO", padrao: "MÉDIO", vida: 40 },
  { uso: "RURAL", tipologia: "AVIÁRIO", padrao: "SUPERIOR", vida: 50 },
  { uso: "RURAL", tipologia: "CHIQUEIRO", padrao: "SIMPLES", vida: 40 },
  { uso: "RURAL", tipologia: "CHIQUEIRO", padrao: "MÉDIO", vida: 50 },
  { uso: "RURAL", tipologia: "ORDENHA MECÂNICA", padrao: "SIMPLES", vida: 30 },
  { uso: "RURAL", tipologia: "ORDENHA MECANIZADA", padrao: "MÉDIO", vida: 40 },
  { uso: "RURAL", tipologia: "ORDENHA MECANIZADA", padrao: "SUPERIOR", vida: 50 },
  { uso: "RURAL", tipologia: "GARAGEM RURAL", padrao: "RÚSTICO", vida: 20 },
  { uso: "RURAL", tipologia: "GARAGEM RURAL", padrao: "SIMPLES", vida: 30 },
  { uso: "RURAL", tipologia: "GARAGEM RURAL", padrao: "MÉDIO", vida: 40 },
  { uso: "RURAL", tipologia: "GARAGEM RURAL", padrao: "SUPERIOR", vida: 50 },
  { uso: "RURAL", tipologia: "ABRIGO DE MÁQUINAS", padrao: "SIMPLES", vida: 30 },
  { uso: "RURAL", tipologia: "ABRIGO DE MÁQUINAS", padrao: "MÉDIO", vida: 40 },
  { uso: "RURAL", tipologia: "ABRIGO DE MÁQUINAS", padrao: "SUPERIOR", vida: 50 }
];